import { apiClient } from "@/lib/api-client";

export type Analytics70Item = {
  Bulan: string;
  NIP: string;
  StatusSekarang: string;
  StatusPegawai: string;
  NamaDosen: string;
  Jurusan: string;
  Fakultas: string;
  Golongan: string;
  Fungsional: string;
  Struktural: string;
  Cluster: string;
  ISPenelitian: string;
  ISPengabdian: string;
  SKSSebelumDikurang: string;
  PointSKSFinal: string;
  KonstantaFungsional: string;
  PendidikanLainnya_SKS: string;
  PendidikanLainnya_Point: string;
  PendidikanLainnya_Batas: string;
  SisaPendidikanPoint: string;
  TotalPenunjangSebelumDikurang: string;
  Penunjang_SKS: string;
  Penunjang_Point: string;
  Penunjang_Batas: string;
  SisaPenunjangPoint: string;
  TotalPoinKinerjaDasar: string;
  TotalPointIKU: string;
  PointPerformance: string;
  PointPosition: string;
  PointPositionCluster: string;
  TotalPoint: string;
  PIR: string;
  Rupiah100Performance: string;
  Rupiah100Position: string;
  Rupiah100Total: string;
  Rupiah100Kotor: string;
  RupiahSerdos: string;
  Realisasi30: string;
  Rupiah70Kotor: string;
  PPh21: string;
  RupiahBersih70: string;
};

export type GetAnalytics70Response = {
  datas: Analytics70Item[];
  message: string;
};

export const getAnalytics70 = async (
  year: number | string,
  semester: number | string,
  periodeID: number | string,
  month: string,
): Promise<Analytics70Item[]> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const resData = await apiClient<GetAnalytics70Response>(
    `${baseUrl}/api/v1/dosen-remun/analytics-70?year=${year}&semester=${semester}&periodeID=${periodeID}&month=${month}`,
    {
      headers: {
        Accept: "application/json",
      },
    },
  );
  return resData.datas || [];
};

export type IkuListItem = {
  kode_iku: string;
  max_point: number;
  max_point_full: number;
  real_point: number;
  final_point: number;
  pir: number;
  rupiah_12_bulan: number;
};

export type Analytics70IkuItem = {
  niu: string;
  nama: string;
  fungsional: string;
  iku_list: IkuListItem[];
};

export type GetAnalytics70IkuResponse = {
  datas: Analytics70IkuItem[];
};

export const getAnalytics70Iku = async (
  year: number | string,
  semester: number | string,
  month: string,
): Promise<Analytics70IkuItem[]> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const resData = await apiClient<GetAnalytics70IkuResponse>(
    `${baseUrl}/api/v1/dosen-remun/analytics-70/iku?year=${year}&semester=${semester}&month=${month}`,
    {
      headers: {
        Accept: "application/json",
      },
    },
  );
  return resData.datas || [];
};
